import React from 'react';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import componentDisplayExtension from '../../commonUtils/ComponentDisplayExtension';
import { isMobile } from 'react-device-detect';

const CopyRightBlock = (props) => {
    //IFRAME: Code to check displaying based on querystring
    if (!componentDisplayExtension.isDisplay(props)) {
        return (<></>)
    }
    //----------------------------------------------

    return(
    <div className={isMobile?"footer_mobile":""}>
        <footer>
            <p>2020 Kimberly-Clark. All Rights Reserved.</p>
        </footer>
    </div>)
};

export default CopyRightBlock;
